import type { ReactNode } from 'node_modules/@types/react';
import { AlertComponent } from '~/_shared/baseComponents/alert';
import {
  ButtonComponent, ButtonSize,
} from '~/_shared/baseComponents/buttons';
import { RegularDropdownComponent } from '~/_shared/baseComponents/dropdown';
import { noop } from '~/_shared/utils/function.helpers';
import { useTranslation } from '~/_shared/utils/hooks';
import { getDemographicsRegionsOptions } from '~/store/demographics/demographics.helpers';
import type { DemographicRegion } from '~/store/demographics/demographics.types';
import { MapToolWrapperComponent } from '../../mapToolWrapper/mapToolWrapper.component';
import {
  alertStyle,
  buttonStyle,
  dropdownTriggerStyle,
  formStyle, labelStyle, settingStyle,
} from './dataLayersTool.styles';

export const DataLayersToolComponent = ({
  error,
  isLegendMode,
}: {
  error?: ReactNode;
  isLegendMode: boolean;
}) => {
  const [t] = useTranslation();

  const isFormValid = true;

  const regionOptions = getDemographicsRegionsOptions({ t, onlyPremiumDataRegions: true });

  return (
    <MapToolWrapperComponent>
      <div>

        {!isLegendMode && (
          <div css={formStyle}>
            <div css={settingStyle}>
              <span css={labelStyle}>
                {t('Select Boundary Type')}
              </span>
              <RegularDropdownComponent<DemographicRegion>
                inPortal
                onChange={noop}
                options={regionOptions}
                triggerStyle={dropdownTriggerStyle({ isPlaceholder: false })}
                value={null}
                placeholder={t('Select Region')}
              />
            </div>

            <ButtonComponent
              css={buttonStyle}
              onClick={isFormValid ? noop : undefined}
              size={ButtonSize.Large}
              text={t('Add')}
              isDisabled={!isFormValid}
            />

            {error && (
              <AlertComponent
                size="small"
                type="danger"
                css={alertStyle}
              >
                {error}
              </AlertComponent>
            )}

          </div>
        )}

      </div>
    </MapToolWrapperComponent>
  );
};
